export enum MidiStatus {
  Playing = "playing",
  NotPlaying = "notPlaying",
  MidiNotLoaded = "midiNotLoaded",
  MidiLoaded = "midiLoaded",
}

export enum PlaybackStateEnum { // from tone js
  stopped = "stopped",
  started = "started",
  paused = "paused",
}

export const KALIMBA_STANDARD_TUNING_: { [key: string]: number } = {
  D6: 0,
  B5: 1,
  G5: 2,
  E5: 3,
  C5: 4,
  A4: 5,
  F4: 6,
  D4: 7,
  C4: 8,
  E4: 9,
  G4: 10,
  B4: 11,
  D5: 12,
  F5: 13,
  A5: 14,
  C6: 15,
  E6: 16,
};

export const PIANO_TUNING: { [key: string]: number } = {
  A0: 0,
  "A#0": 1,
  Bb0: 1,
  B0: 2,
  C1: 3,
  "C#1": 4,
  Db1: 4,
  D1: 5,
  "D#1": 6,
  Eb1: 6,
  E1: 7,
  F1: 8,
  "F#1": 9,
  Gb1: 9,
  G1: 10,
  "G#1": 11,
  Ab1: 11,
  A1: 12,
  "A#1": 13,
  Bb1: 13,
  B1: 14,
  C2: 15,
  "C#2": 16,
  Db2: 16,
  D2: 17,
  "D#2": 18,
  Eb2: 18,
  E2: 19,
  F2: 20,
  "F#2": 21,
  Gb2: 21,
  G2: 22,
  "G#2": 23,
  Ab2: 23,
  A2: 24,
  "A#2": 25,
  Bb2: 25,
  B2: 26,
  C3: 27,
  "C#3": 28,
  Db3: 28,
  D3: 29,
  "D#3": 30,
  Eb3: 30,
  E3: 31,
  F3: 32,
  "F#3": 33,
  Gb3: 33,
  G3: 34,
  "G#3": 35,
  Ab3: 35,
  A3: 36,
  "A#3": 37,
  Bb3: 37,
  B3: 38,
  C4: 39,
  "C#4": 40,
  Db4: 40,
  D4: 41,
  "D#4": 42,
  Eb4: 42,
  E4: 43,
  F4: 44,
  "F#4": 45,
  Gb4: 45,
  G4: 46,
  "G#4": 47,
  Ab4: 47,
  A4: 48,
  "A#4": 49,
  Bb4: 49,
  B4: 50,
  C5: 51,
  "C#5": 52,
  Db5: 52,
  D5: 53,
  "D#5": 54,
  Eb5: 54,
  E5: 55,
  F5: 56,
  "F#5": 57,
  Gb5: 57,
  G5: 58,
  "G#5": 59,
  Ab5: 59,
  A5: 60,
  "A#5": 61,
  Bb5: 61,
  B5: 62,
  C6: 63,
  "C#6": 64,
  Db6: 64,
  D6: 65,
  "D#6": 66,
  Eb6: 66,
  E6: 67,
  F6: 68,
  "F#6": 69,
  Gb6: 69,
  G6: 70,
  "G#6": 71,
  Ab6: 71,
  A6: 72,
  "A#6": 73,
  Bb6: 73,
  B6: 74,
  C7: 75,
  "C#7": 76,
  Db7: 76,
  D7: 77,
  "D#7": 78,
  Eb7: 78,
  E7: 79,
  F7: 80,
  "F#7": 81,
  Gb7: 81,
  G7: 82,
  "G#7": 83,
  Ab7: 83,
  A7: 84,
  "A#7": 85,
  Bb7: 86,
  B7: 86,
  C8: 87,
};

interface INOTE_NUMBER_TO_NOTE {
  [key: number]: string;
}
export const NOTE_NUMBER_TO_NOTE: INOTE_NUMBER_TO_NOTE = {
  21: "A0",
  22: "A#0",
  23: "B0",
  24: "C1",
  25: "C#1",
  26: "D1",
  27: "D#1",
  28: "E1",
  29: "F1",
  30: "F#1",
  31: "G1",
  32: "G#1",
  33: "A1",
  34: "A#1",
  35: "B1",
  36: "C2",
  37: "C#2",
  38: "D2",
  39: "D#2",
  40: "E2",
  41: "F2",
  42: "F#2",
  43: "G2",
  44: "G#2",
  45: "A2",
  46: "A#2",
  47: "B2",
  48: "C3",
  49: "C#3",
  50: "D3",
  51: "D#3",
  52: "E3",
  53: "F3",
  54: "F#3",
  55: "G3",
  56: "G#3",
  57: "A3",
  58: "A#3",
  59: "B3",
  60: "C4",
  61: "C#4",
  62: "D4",
  63: "D#4",
  64: "E4",
  65: "F4",
  66: "F#4",
  67: "G4",
  68: "G#4",
  69: "A4",
  70: "A#4",
  71: "B4",
  72: "C5",
  73: "C#5",
  74: "D5",
  75: "D#5",
  76: "E5",
  77: "F5",
  78: "F#5",
  79: "G5",
  80: "G#5",
  81: "A5",
  82: "A#5",
  83: "B5",
  84: "C6",
  85: "C#6",
  86: "D6",
  87: "D#6",
  88: "E6",
  89: "F6",
  90: "F#6",
  91: "G6",
  92: "G#6",
  93: "A6",
  94: "A#6",
  95: "B6",
  96: "C7",
  97: "C#7",
  98: "D7",
  99: "D#7",
  100: "E7",
  101: "F7",
  102: "F#7",
  103: "G7",
  104: "G#7",
  105: "A7",
  106: "A#7",
  107: "B7",
  108: "C8",
  109: "C#8",
  110: "D8",
  111: "D#8",
  112: "E8",
  113: "F8",
  114: "F#8",
  115: "G8",
  116: "G#8",
  117: "A8",
  118: "A#8",
  119: "B8",
  120: "C9",
  121: "C#9",
  122: "D9",
  123: "D#9",
  124: "E9",
  125: "F9",
  126: "F#9",
  127: "G9",
};
